var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticStyle: { "border-radius": "20px" },
      attrs: { title: "活动详情", visible: _vm.dialogVisible, width: "60%" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _vm.dialogVisible
        ? _c("div", { staticClass: "fc" }, [
            _c(
              "div",
              { staticStyle: { width: "100%" } },
              [
                _c("el-divider"),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "search_criteria" }, [
                    _c("div", { staticStyle: { "margin-left": "0" } }, [
                      _c(
                        "div",
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "输入会员手机号查询",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryData.phoneNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryData, "phoneNo", $$v)
                              },
                              expression: "queryData.phoneNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "输入会员ID查询",
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryData.memberId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryData, "memberId", $$v)
                            },
                            expression: "queryData.memberId",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "flex",
                        staticStyle: { width: "fit-content", height: "40px" },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { height: "40px" },
                            attrs: { type: "primary" },
                            on: { click: _vm.onInquireList },
                          },
                          [_vm._v("查询")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "ml10",
                            staticStyle: { height: "40px" },
                            attrs: { type: "info", plain: "" },
                            on: { click: _vm.onInitializeList },
                          },
                          [_vm._v("重置")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", plain: "" },
                            on: { click: _vm.onRecharge },
                          },
                          [_vm._v("导出")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                data: _vm.tableData,
                "tooltip-effect": "dark",
              },
              on: { "sort-change": _vm.sortChange },
            },
            [
              _c("el-table-column", {
                attrs: { label: "会员昵称", prop: "nickName", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              color: "#4d8aff",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onUserDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.nickName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "会员手机号",
                  prop: "phoneNo",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "报名时间", prop: "signTime", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  sortable: "custom",
                  label: "累计数据",
                  prop: "rankValue",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "奖励金额", prop: "reward", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "奖励发放状态",
                  prop: "rewardStatus",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            style: {
                              color:
                                scope.row.rewardStatus === 1 ? "green" : "red",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.rewardStatus === null
                                  ? "-"
                                  : _vm.statusBuff[scope.row.rewardStatus]
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "奖励发放时间",
                  prop: "settleTime",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "数据更新时间",
                  prop: "updateTime",
                  align: "center",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt20 page_box" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryData.page,
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.queryData.size,
                  layout: "total, prev, pager, next, sizes,jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }